export default __webpack_public_path__ + "static/media/JeffreyLee.cb67858c.png";